// extracted by mini-css-extract-plugin
export default {"order":"OutletWrapper_order__ZwNt7"};